import { Form } from 'formik'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'

import { TextFieldInput } from '@dhl/formik'
import { AddressInput } from '@dhl/input-address'
import { Box, Button, Grid, H6 } from '@dhl-ui/components'

import { links } from '~/AppRoutes'
import { CountrySelect } from '~/common/components/addresses'

type ReturnHubProps = {
  country: string
  id?: string
  onCountryChange: (country: string) => void
}

export const ReturnHubForm = ({ id, country, onCountryChange }: ReturnHubProps) => {
  const { t } = useTranslation()
  const navigate = useNavigate()

  return (
    <Form>
      <Box pt={1} pb={1}>
        <Grid container spacing={2}>
          <Grid size={{ xs: 12 }}>
            <H6>{t('admin.returnHubPage.accountInformation')}</H6>
          </Grid>
          <Grid size={{ xs: 6 }}>
            <TextFieldInput fullWidth label={t('admin.returnHubPage.name')} name="name" />
          </Grid>
          <Grid size={{ xs: 12 }}>
            <H6>{t('admin.returnHubPage.addressInformation')}</H6>
          </Grid>
          <Grid>
            <AddressInput carrier="parcel" country={country} name="address" />
          </Grid>
          <Grid size={{ xs: 6 }}>
            <CountrySelect fieldName="address.countryCode" onChangeCountryCode={onCountryChange} />
          </Grid>
        </Grid>
      </Box>
      <Box mt={2} mb={2} display="flex" justifyContent="flex-end">
        <Box mr={1}>
          <Button
            color="primary"
            variant="text"
            size="medium"
            onClick={() => navigate(id ? links.returnHubsDetailLink(id) : links.returnHubsLink())}
          >
            {t('admin.returnHubPage.cancel')}
          </Button>
        </Box>
        <Button color="primary" type="submit" variant="contained" size="medium">
          {t('admin.returnHubPage.returnHubForm.updateReturnHub')}
        </Button>
      </Box>
    </Form>
  )
}
